module.exports = __webpack_public_path__ + "assets/img/w3.d3ef8cf3.png";